import { Text } from "../../../../../../../../library/text";
import { ContentWrapper } from "./styled";

export const Animation = () => {
  return (
    <ContentWrapper>
      <Text color="dark" size="extrasmall">
        Animasjoner vil bli tilgjengelig snart.
      </Text>
    </ContentWrapper>
  );
};

export default Animation;
